/**
 * Determine the mobile/web operating system.
 * This function returns one of 'iOS', 'Android', or 'Web'.
 *
 * @returns {String}
 */
const getPlatform = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  let platformName;

  if ('ontouchstart' in document.documentElement && /android/i.test(userAgent)) {
    platformName = 'Android';
  } else if ('ontouchstart' in document.documentElement && /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    platformName = 'iOS';
  } else {
    platformName = 'Web';
  }
  return platformName;
};

const getBrowser = () => {
  const userAgent = navigator.userAgent || '';

  let browserName;

  if (userAgent.match(/chrome|chromium|crios/i)) {
    browserName = 'chrome';
  } else if (userAgent.match(/firefox|fxios/i)) {
    browserName = 'firefox';
  } else if (userAgent.match(/safari/i)) {
    browserName = 'safari';
  } else if (userAgent.match(/opr\//i)) {
    browserName = 'opera';
  } else if (userAgent.match(/edg/i)) {
    browserName = 'edge';
  } else {
    browserName = 'No browser detected';
  }
  return browserName;
};

const getSource = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  let platform;

  if ('ontouchstart' in document.documentElement && /android/i.test(userAgent)) {
    platform = 1; // Android
  } else if ('ontouchstart' in document.documentElement && /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    platform = 3; // iOS
  } else {
    platform = 2; // Web
  }
  return platform;
};

const getLog = (level, err) => {
  const log = [
    {
      level,
      message: err,
    },
  ];
  return log;
};

const getCsPortalLog = (type, source, msg, response = {}) => {
  const log = {
    type,
    source,
    url: window.location.href,
    msg,
    response,
  };
  return [log];
};

export { getPlatform, getBrowser, getSource, getLog, getCsPortalLog };
